module.exports = __webpack_public_path__ + "img/03-2-1数据分析.3fa31e04.svg";